import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  getLearnWorldsUserTokenAction,
  getOneLinkAction,
} from 'root-redux/actions/user'
import {
  selectLearnWorldsAutologinLink,
  selectOneLink,
  selectUUID,
} from 'root-redux/selects/user'
import { TAppDispatch } from 'root-redux/store/store'

import { useUserAccountType } from 'hooks/useUserAccountType'

import { getAppConfigMap } from 'helpers/getAppConfigMap'

export const useUserRedirectionLink = () => {
  const dispatch: TAppDispatch = useDispatch()

  const uuid = useSelector(selectUUID)
  const oneLink = useSelector(selectOneLink)
  const learnWorldsLink = useSelector(selectLearnWorldsAutologinLink)

  const { appConfig } = getAppConfigMap()
  const { learnworldsCourseLink } = appConfig

  const isLearnWorldsUser = useUserAccountType()

  const redirectionLink = isLearnWorldsUser ? learnWorldsLink : oneLink

  useEffect(() => {
    if (isLearnWorldsUser && !learnWorldsLink) {
      dispatch(
        getLearnWorldsUserTokenAction(
          uuid,
          `${learnworldsCourseLink}/?msg=not-logged-in`,
        ),
      )
    }

    if (!isLearnWorldsUser && !oneLink) {
      dispatch(getOneLinkAction())
    }
  }, [
    learnWorldsLink,
    oneLink,
    uuid,
    dispatch,
    learnworldsCourseLink,
    isLearnWorldsUser,
  ])

  return redirectionLink
}
